import { Component, type ErrorInfo, type ReactNode } from "react"

interface Props {
  children: ReactNode
  fallback?: ReactNode
}
interface State {
  hasError: boolean
  error?: Error
}

/**
 * ErrorBoundary — chặn lỗi runtime của 1 trang để KHÔNG làm trắng toàn app.
 * [BLACK BOX] — bọc sẵn quanh router trong App.tsx. AI không cần sửa file này.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack)
  }

  reset = () => this.setState({ hasError: false, error: undefined })

  render() {
    if (!this.state.hasError) return this.props.children
    if (this.props.fallback) return this.props.fallback
    return (
      <div
        data-upbo-id="error-boundary"
        data-upbo-type="container"
        data-upbo-label="Error Boundary"
        className="min-h-screen w-full flex items-center justify-center p-6 text-center"
      >
        <div className="max-w-md flex flex-col items-center gap-4">
          <div className="text-5xl">⚠️</div>
          <h1 className="text-3xl text-text">Something went wrong</h1>
          <p className="text-sm text-text-muted break-words">
            {this.state.error?.message ?? "Unknown error"}
          </p>
          <button
            onClick={this.reset}
            className="h-11 px-6 rounded-squircle bg-ink text-on-ink text-[12px] font-medium uppercase tracking-[0.14em] hover:bg-primary hover:text-on-primary transition-colors"
          >
            Reload this view
          </button>
        </div>
      </div>
    )
  }
}
